import type { TemplateLibraryEntry } from '@fluenceur/types';

/**
 * Pick the brand template used to prefill the mono proposal-email module
 * (FOU-836, A1). The template library list is brand-scoped and already carries
 * the system default per (channel, context, language) pair, so resolution is
 * client-side: the entry for the wanted language (brand default first), then
 * the English fallback, then anything. Returns null when the pair has no entry
 * yet — the editor then starts empty rather than blocking the flow.
 */
export const pickCollabEmailTemplate = (
  entries: readonly TemplateLibraryEntry[] | undefined,
  language: string
): TemplateLibraryEntry | null => {
  if (!entries || entries.length === 0) return null;
  const pick = (list: readonly TemplateLibraryEntry[]): TemplateLibraryEntry | null =>
    list.find((entry) => entry.isDefault) ??
    list.find((entry) => entry.isSystemDefault) ??
    list[0] ??
    null;

  const inLanguage = entries.filter((entry) => entry.language === language);
  if (inLanguage.length > 0) return pick(inLanguage);
  const english = entries.filter((entry) => entry.language === 'en');
  if (english.length > 0) return pick(english);
  return pick(entries);
};

/** The editor takes a serialized Lexical string; library entries store JSON. */
export const templateEditorContent = (entry: TemplateLibraryEntry | null): string | null =>
  entry?.contentLexicalJson ? JSON.stringify(entry.contentLexicalJson) : null;
